var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHorn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 74,
    viewBox: "0 0 64 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.303 73.785C24.5644 73.7868 25.8046 73.4364 26.9027 72.768L33.7464 68.6558C35.4365 67.6302 36.6806 65.9254 37.2064 63.9145C37.7323 61.9036 37.4971 59.7503 36.5522 57.9257L33.3494 51.75L30.9679 53.2239L34.157 59.3849C34.7489 60.5295 34.8969 61.8796 34.5688 63.1412C34.2407 64.4028 33.4629 65.4737 32.405 66.1207L25.5614 70.2329C24.5674 70.8392 23.3991 71.0242 22.2852 70.7516C21.1712 70.4789 20.1919 69.7684 19.539 68.759L15.3643 62.3032L13.1196 63.9835L17.2258 70.4393C17.9095 71.4873 18.8204 72.3399 19.8794 72.9229C20.9385 73.506 22.1137 73.8019 23.303 73.785Z",
    fill: "#2AB9B8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.70312 63.0553L8.99928 69.8353L54.9064 41.2266L29.2565 13.6055L2.70312 63.0553Z",
    fill: "#2AB9B8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M29.2565 13.6055L27.9699 15.9932L24.4112 22.6406L21.5095 28.0056L17.9645 34.6235L15.0627 40.018L11.5177 46.6359L8.61604 52.0157L5.07104 58.6336L2.70312 63.0406L8.99928 69.8353L10.327 69.0099L15.5692 65.7379L19.8533 63.0701L25.1092 59.798L29.3797 57.1302L34.6356 53.8581L38.8923 51.2051L44.1756 47.9182L48.4323 45.2652L54.9064 41.2266L29.2565 13.6055Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M29.2563 13.6055L27.9697 15.9932L44.1755 47.9182L48.4322 45.2652L36.1136 20.9898L29.2563 13.6055Z",
    fill: "#008685"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M24.4115 22.6406L21.5098 28.0057L34.6359 53.8582L38.8926 51.2051L24.4115 22.6406Z",
    fill: "#008685"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M17.9647 34.625L15.063 40.0195L25.1095 59.7995L29.3799 57.1317L17.9647 34.625Z",
    fill: "#008685"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M11.5179 46.6328L8.61621 52.0126L15.5694 65.7348L19.8535 63.067L11.5179 46.6328Z",
    fill: "#008685"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M5.07104 58.6328L2.70312 63.0398L8.99928 69.8346L10.327 69.0092L5.07104 58.6328Z",
    fill: "#008685"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9567 13.8101L54.7145 43.76C55.0454 44.1147 55.4933 44.3137 55.9601 44.3137C56.4269 44.3137 56.8748 44.1147 57.2056 43.76C57.535 43.4037 57.7198 42.9215 57.7198 42.4188C57.7198 41.9161 57.535 41.4338 57.2056 41.0775L29.4478 11.1865C29.117 10.8319 28.6691 10.6328 28.2023 10.6328C27.7355 10.6328 27.2876 10.8319 26.9567 11.1865C26.6438 11.5401 26.4692 12.0098 26.4692 12.4983C26.4692 12.9867 26.6438 13.4565 26.9567 13.8101Z",
    fill: "#2AB9B8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M0.636078 64.3949L7.72608 72.0298C7.92586 72.2468 8.16358 72.4191 8.42552 72.5366C8.68746 72.6542 8.96842 72.7147 9.2522 72.7147C9.53598 72.7147 9.81698 72.6542 10.0789 72.5366C10.3409 72.4191 10.5786 72.2468 10.7784 72.0298C10.9803 71.8134 11.1406 71.5562 11.2499 71.2729C11.3593 70.9896 11.4156 70.6858 11.4156 70.379C11.4156 70.0722 11.3593 69.7684 11.2499 69.4851C11.1406 69.2018 10.9803 68.9446 10.7784 68.7282L3.70202 61.1081C3.50106 60.8906 3.26218 60.718 2.99911 60.6003C2.73603 60.4825 2.45395 60.4219 2.16905 60.4219C1.88415 60.4219 1.60206 60.4825 1.33899 60.6003C1.07591 60.718 0.837031 60.8906 0.636078 61.1081C0.43454 61.3232 0.274539 61.5792 0.165369 61.8613C0.0561982 62.1433 0 62.4459 0 62.7515C0 63.0571 0.0561982 63.3596 0.165369 63.6417C0.274539 63.9238 0.43454 64.1798 0.636078 64.3949Z",
    fill: "#2AB9B8"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0825 11.3639L45.3675 0H42.0825V11.3639Z",
    fill: "#2AB9B8"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8271 15.7426L59.451 5.67578L62.4211 8.74153L51.8271 15.7426Z",
    fill: "#2AB9B8"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9062 25.0703H63.7756L62.4205 27.4138L53.2227 25.0703",
    fill: "#2AB9B8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHorn);
export default __webpack_public_path__ + "static/media/horn.0117574e85e848bfc51d1b55ca576fe3.svg";
export { ForwardRef as ReactComponent };